import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";

import { useUser } from "@/providers/context";
import { Playlist, PlaylistResponse, renamePlaylist } from "@/api";

export const useRenamePlaylist = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();

  return useMutation<
    PlaylistResponse | undefined,
    AxiosError<{ error: string }>,
    Pick<Playlist, "PlaylistId" | "PlaylistName">
  >(
    async ({ PlaylistId, PlaylistName }) => {
      if (uid) {
        return await renamePlaylist({ user_id: uid, PlaylistId, PlaylistName });
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.setQueryData(["playlists", uid], data);
        }
      },
    },
  );
};
